import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../../components/AtiraIcon";
import { Flex } from "../../../../components/Flex";
import { Rounded } from "../../../../theme/Rounded";
import { Spacing } from "../../../../theme/Spacing";
import { TestIDs } from "../../../../tests/types/testIds";

const Row = styled(Flex)`
  flex-shrink: 0;
  align-items: center;
  gap: ${Spacing.s};
  padding: ${Spacing.s} ${Spacing.m};
  border-bottom: 1px solid ${({ theme }) => theme.darkSub};
  background: ${({ theme }) => theme.white};
`;

const SearchInput = styled.input`
  flex: 1;
  min-width: 0;
  padding: ${Spacing.xs} ${Spacing.s};
  border: 1px solid ${({ theme }) => theme.darkSub};
  border-radius: ${Rounded.pill};
  background: ${({ theme }) => theme.lightSub};
  color: ${({ theme }) => theme.textColor};
  font: inherit;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.main};
  }
`;

const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${Spacing.xs};
  border: none;
  border-radius: ${Rounded.circle};
  background: transparent;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.lightMain};
  }
`;

type Props = {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
};

export const WAChatsSearch: React.FC<Props> = ({
  value,
  onChange,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Row>
      <SearchInput
        autoFocus
        value={value}
        placeholder={t("integration.whatsapp.chatsPanel.search.placeholder")}
        data-testid={TestIDs.integration.whatsappMeta.chat.search.input}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            onClose();
          }
        }}
      />

      <CloseButton
        type="button"
        title={t("integration.whatsapp.chatsPanel.search.close")}
        data-testid={TestIDs.integration.whatsappMeta.chat.search.close}
        onClick={onClose}
      >
        <AtiraIcon icon={faXmark} size="sm" />
      </CloseButton>
    </Row>
  );
};
